// extracted by mini-css-extract-plugin
export default {"decimalRadio":"DecimalsRadio_decimalRadio__n94B9","input":"DecimalsRadio_input__7t2qG","label":"DecimalsRadio_label__QvSt+"};